import React from "react";
import * as firebase from "firebase";
import "./BotFinish.css";
import { newSlack } from "../../util/slack";
import google from "../../assets/img/google.png";

const signIn = () => {
  const provider = new firebase.auth.GoogleAuthProvider();
  provider.addScope("https://www.googleapis.com/auth/drive.metadata.readonly");
  firebase
    .auth()
    .signInWithPopup(provider)
    .then(result => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      const token = result.credential.accessToken;
      alert(token);
      // var user = result.user;
    })
    .catch(error => {
      console.log(error);
    });
};

class BotFinish extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      err: null,
      success: false,
    };
    this.userToSlack = this.userToSlack.bind(this);
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => this.userToSlack(user));
  }

  userToSlack(user) {
    const url = new URL(window.location);
    const c = url.searchParams.get("code");
    const FD = new FormData();

    // Push our data into our FormData object
    FD.append("code", c);
    if (user) {
      // User is signed in.
      newSlack(FD)
        .then(() => this.setState({ err: null, success: true }))
        .catch(err => this.setState({ err: err.error }));
    } else {
      // No user is signed in.
      this.setState({ err: "Oops, you're not logged in" });
    }
  }

  render() {
    return (
      <div className="botfinish">
        <div>
          <a href="https://slack.com/oauth/authorize?client_id=379832235377.380154477524&scope=incoming-webhook,bot">
            <img
              alt="Add to Slack"
              height="40"
              width="139"
              src="https://platform.slack-edge.com/img/add_to_slack.png"
              srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
            />
          </a>
        </div>
        <div>
          <div
            onClick={signIn}
            style={{ cursor: "pointer" }}
            role="button"
            tabIndex="0"
          >
            <img alt="Sign in with google" src={google} />
          </div>
        </div>
        <div>{this.state.err}</div>
        {this.state.success && <div>Success!</div>}
      </div>
    );
  }
}

export default BotFinish;



// WEBPACK FOOTER //
// ./src/pages/BotFinish/BotFinish.js